import { ReportingPanel } from '../../../../packages/reporting-ui/Panel';
import { getAccessToken } from '../store/auth';
const getHeaders=()=>({Authorization:`Bearer ${getAccessToken()??''}`});
export default function ReportsPage(){return <ReportingPanel base="/api/traders/reporting" role="trader" getHeaders={getHeaders}/>;}
